import React, { Component } from 'react';
import { WrappedFieldInputProps } from 'redux-form';
import { ChromePicker, ColorResult } from 'react-color';
import onClickOutside from 'react-onclickoutside';
import { Manager, Reference, Popper } from 'react-popper';

import styles from './color-picker.module.scss';

export interface ColorPickerProps {
  preview?: boolean;
}

interface Props extends Partial<WrappedFieldInputProps>, ColorPickerProps {
  checked?: boolean;
  disabled?: boolean;
  color?: string;
}

interface ColorPickerState {
  open: boolean;
}

class ColorPicker extends Component<Props, ColorPickerState> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleOnFocus = () => {
    this.setState(prev => ({ open: !prev.open }));
  };

  handleOnBlur = () => {
    this.setState({ open: false });
  };

  handleOnColorChange = (color: ColorResult) => {
    const { onChange } = this.props;

    if (typeof onChange === 'function') {
      onChange(color.hex);
    }
  };

  handleClickOutside = () => {
    this.handleOnBlur();
  };

  render() {
    const { open } = this.state;
    const { value, preview = true, disabled } = this.props;

    return (
      <Manager>
        <div className={styles.wrapper}>
          <Reference>
            {({ ref }) => (
              <>
                {preview && <div style={{ background: value }} className={styles.preview} />}
                <input
                  type="text"
                  value={value}
                  readOnly
                  onFocus={this.handleOnFocus}
                  ref={ref}
                  className="text-input form-control"
                  disabled={disabled}
                />
              </>
            )}
          </Reference>
          {open && (
            <Popper placement="bottom-start">
              {({ ref, style, placement }) => (
                <div
                  ref={ref}
                  style={{ ...style, zIndex: 9 }}
                  data-placement={placement}
                  className={styles.pickerWrapper}
                >
                  <ChromePicker onChangeComplete={this.handleOnColorChange} color={value} disableAlpha />
                </div>
              )}
            </Popper>
          )}
        </div>
      </Manager>
    );
  }
}

export const ColorPickerComponent = onClickOutside(ColorPicker);
